export const pathMatches = (pathname: string, pages: string[]) =>
  pages.some(path => {
    const regex = new RegExp('^' + path.replace(/:\w+/g, '\\w+') + '$', 'i');
    return regex.test(pathname);
  });
